import { useContext, createContext } from "react"; // https://reactjs.org/docs/context.html

export var StoryblokContext = /*#__PURE__*/createContext({});
export var StoryblokProvider = StoryblokContext.Provider;
export var useStoryblok = () => useContext(StoryblokContext);
//# sourceMappingURL=StoryblokProvider.js.map